/**
 * Formats dealer location to display format address
 * @param {DealerLocation} location
 * @returns {string}
 */
function formatDealerAddress(location) {
  if (!location) return '';

  const { address = '', city = '', province = '', postalCode = '' } = location;
  return `${address}, ${city}, ${province} ${postalCode}`;
}

export default formatDealerAddress;
